<template>
  <v-container class="pa-0" fluid>

    <v-row v-if="matrixPraemien"
           justify="center"
           class="gewerbepricematrix ma-0 mb-6">

      <div v-if="(!hideNotKompex && showKompex)" class="brackets">
        <div :style="bracketStyles.beforeYourSelectionStyle"></div>
        <div :style="bracketStyles.yourSelectionStyle">
          <div class="bracket-text"><span>Ihre Auswahl:</span></div>
          <div class="your-selection"></div>
        </div>
        <div :style="bracketStyles.beforeAlternativeStyle"></div>
        <div :style="bracketStyles.alternativeStyle">
          <div class="bracket-text kompex-text">
            <span class="text-center">Alternative: <span class="font-weight-bold">KOMPEX</span></span>
          </div>
          <div class="alternative"></div>
        </div>
      </div>
      <div v-if="!(!hideNotKompex && showKompex) && (isKompex || isKompexOhneI)" class="brackets">
        <div :style="bracketStyles.beforeYourSelectionStyle"></div>
        <div :style="bracketStyles.alternativeStyle">
          <div class="bracket-text kompex-text">
            <span class="text-center font-weight-bold">KOMPEX</span>
          </div>
          <div class="alternative"></div>
        </div>
      </div>

      <v-col cols="12" class="pa-0"/>

      <v-col class="matrix-col small ma-0 pa-0">

        <div class="matrix-tile header-tile">
          <v-tooltip top>
                <template v-slot:activator="{on}">
                  <div v-on="on">
                    <div style="white-space:nowrap">SB gewerblich</div>
                    <div v-if="showKompex" class="kompex-text">SB privat</div>
                  </div>
                </template>
                <div>
                  <span class="caption">Selbstbeteiligung gewerblich</span><br/>
                  <span v-if="showKompex" class="caption">Selbstbeteiligung privat</span>
                </div>
          </v-tooltip>
        </div>

        <template v-for="(row, i) in matrixDefinition.rows">
          <div v-if="showRow(row)"
               :key="'row' + i"
               class="matrix-tile mt-2">
            <div class="text-right">
              <div :class="{'pl-2': row.gewerbe < 1000}">{{ row.gewerbe }} €</div>
              <div v-if="showKompex" class="kompex-text">{{ row.privat }} €</div>
            </div>
          </div>
        </template>

      </v-col>

      <template v-for="(col, i) in matrixDefinition.columns">
        <v-col v-if="showColumn(col)"
               :key="'col' + i"
               :class="col.style"
               class="matrix-col pa-0">

          <div class="matrix-tile header-tile">
            <template v-if="col.name === 'KOMPEX'">
              <v-tooltip top>
                <template v-slot:activator="{on}">
                <div v-on="on">Gewerbe und Privat</div>
                </template>
                <div>
                  <span class="caption">Gewerbe: Firma, Verkehr, Immobilien</span><br/>
                  <span class="caption">Privat: Privat, Beruf, Verkehr, Wohnen</span>
                </div>
              </v-tooltip>

            </template>
            <template v-else>
              {{ col.name }}
            </template>
          </div>

          <template v-for="(row, j) in matrixDefinition.rows">
            <div v-if="showRow(row)"
                 :key="'col' + i + 'row' + j"
                 :class="{'selectable': !!matrixPraemien[`GW${row.gewerbe}P${row.privat}`][col.key], 'selected': isTileSelected(row, col.key), 'schublade': isSchublade()}"
                 class="matrix-tile price-tile mt-2" @click="select(row, col)">
              {{ matrixPraemien[`GW${row.gewerbe}P${row.privat}`][col.key] ? $helpers.formatCurrency(matrixPraemien[`GW${row.gewerbe}P${row.privat}`][col.key]) : '-' }}
            </div>
          </template>

        </v-col>
      </template>

    </v-row>
    <v-label v-if="showKompex && !isKompex && !showKompexOhneImmobilien && immobilien.some( i => {return i.art === 'VERMIET'}) ">
      Hinweis: KOMPEX beinhaltet keine <b>vermieteten</b> gewerblichen Immobilien.
    </v-label>
    <v-btn v-if="!showKompex && gewerbeProductAvailable(personen, hasMvUnternehmen, ['SPEZ-PBV+MIET'])"
           class="kompex-bg mt-4 standard-button"
           @click="showMitarbeiterDialog = true">Vergleich mit KOMPEX Komplettpaket anzeigen
    </v-btn>
    <v-checkbox v-if="showNoImmoOption"
                v-model="showKompexOhneImmobilien"
                hide-details
                label="gewerblichen Immobilien-Rechtsschutz im KOMPEX ausschließen"
                class="mt-4 no-max-width" />

    <v-checkbox v-if="showKompex && pksAllowed"
                v-model="excludeGF"
                hide-details
                color="warning"
                class="mt-4 no-max-width"
                @change="excludeGFChanged()">
      <template v-slot:label>
        <schublade-tooltip>Privat-Rechtsschutz für Geschäftsführer ausschließen</schublade-tooltip>
      </template>
    </v-checkbox>

    <v-dialog v-model="showMitarbeiterDialog"
              width="816px"
              persistent
              @keydown.enter="validateDialog()"
              @keydown.esc="showMitarbeiterDialog = false">
      <v-card class="pa-6 dmb-form-text round-corners black87">
        <mitarbeiter-data state-path="gewerbe.mitarbeiter" scope="gewerbemitarbeiter" kompex />
        <v-container fluid class="pa-0">
          <v-row justify="end">
            <v-btn class="standard-button mx-2"
                   @click="showMitarbeiterDialog = false">Abbrechen
            </v-btn>
            <v-btn color="primary"
                   class="standard-button mx-2"
                   @click="validateDialog()">Daten übernehmen
            </v-btn>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

  </v-container>
</template>
<script>
import ValidationMixin from "@/components/helper/ValidationMixin";
import twowayBinding from "@/store/twowayBindingMixin";
import { mapGetters, mapState } from 'vuex';
import { mapTwoWay } from '../../store/twowayBindingMixin';
import MitarbeiterData from './MitarbeiterData';
import {RIGHTS} from "@/store/user";
import SchubladeTooltip from './SchubladeTooltip';

export default {
  components: { SchubladeTooltip, MitarbeiterData },
  mixins: [twowayBinding, ValidationMixin],
  data() {
    return {
      matrixPraemien: null,
      showMitarbeiterDialog: false
    };
  },
  computed: {
    ...mapState({
      personen: state => state.gewerbe.personen,
      deckungen: state => state.gewerbe.deckungen,
      hasMvUnternehmen: state => state.gewerbe.ui.hasMvUnternehmen,
      mitarbeiter: state => state.gewerbe.mitarbeiter,
      fahrzeuge: state => state.gewerbe.fahrzeuge,
      immobilien: state => state.gewerbe.immobilien,
      wohnungen: state => state.gewerbe.wohnungen,
      ferienwohnungen: state => state.gewerbe.ferienwohnungen,
      activeStepNumber: state => state.s.gewerbe.activeStepNumber,
      laufzeit: state => state.gewerbe.vertrag.laufzeit,
      zahlweise: state => state.gewerbe.vertrag.zahlweise
    }),
    ...mapTwoWay([
      'produkte',
      'matrixSelection',
      'isKompex',
      'isKompexOhneI',
      'hideNotKompex',
      'showKompex',
      'showKompexOhneImmobilien',
      'excludeGF'
    ], {}, 'gewerbe.ui'),
    ...mapGetters([
      'gewerbeProductAvailable',
      'anzahlMitarbeiter'
    ]),
    pksAllowed() {
      return this.$store.getters.checkAuthorization(RIGHTS.TARIFSELECTION);
    },
    isMietz() {
      return !!(this.deckungen.find(d => d.produkt === 'MIETZ'));
    },
    bracketStyles() {
      const beforeYourSelectionStyle = { width: `${this.produkte.length === 1 ? 106 : 98}px` };
      let width;
      if (this.produkte.length === 1) {
        width = 110;
      } else {
        width = this.produkte.length * 90 + (this.produkte.length - 1) * 8 + 110 + 16;
      }
      const yourSelectionStyle = { width: `${width - 2}px`};
      const beforeAlternativeStyle = this.showKompex ? { width: '16px' } : { display: 'none' };
      width = 0;
      if (this.showKompex) {
        width = 110;
      }
      if (this.showKompexOhneImmobilien) {
        width += 110 + 16;
      }
      const alternativeStyle = width > 0 ? { width: `${width - 2}px` } : { display: 'none' };
      return {
        beforeYourSelectionStyle,
        yourSelectionStyle,
        beforeAlternativeStyle,
        alternativeStyle
      };
    },
    matrixDefinition() {
      let columns = [
        { name: 'Firmen', key: 'FIRM', style: 'white small', kompex: null, kompexOhneI: null },
        { name: 'Verkehr', key: ['VERKA', 'VERKB', 'VERKC'], style: 'white small', kompex: null, kompexOhneI: null },
        { name: 'Immobilien', key: 'MIET', style: 'white small', kompex: null, kompexOhneI: null }
      ];
      columns = columns.filter(c => this.produkte.indexOf(c.key) > -1 || c.name === 'Verkehr' && this.produkte.indexOf('VERK') > -1);
      if (this.produkte.length > 1) {
        let produkte = this.produkte.filter(p => p !== 'VERK');
        if (this.produkte.indexOf('VERK') > -1) produkte = produkte.concat(['VERKA', 'VERKB', 'VERKC']);
        columns.push({ name: 'Beitrag', key: produkte, style: 'beitrag' });
      } else if (this.produkte.length === 1) {
        columns[0].style = 'beitrag';
      }
      columns.push( { name: 'KOMPEX', key: 'SPEZ-PBV+MIET', style: 'kompex', kompex: true });
      columns.push( { name: 'ohne gewerbl. Immobilien-RS', key: 'SPEZ-PBV', style: 'kompexohnei', kompexOhneI: true });
      return {
        columns,
        rows: [
          { gewerbe: '1000', privat: '500' },
          { gewerbe: '500', privat: '300' },
          { gewerbe: '300', privat: '300' },
          { gewerbe: '300', privat: '150' },
          { gewerbe: '150', privat: '150' },
         ]
      };
    },
    showNoImmoOption: function() {
      let immoCol = this.matrixDefinition.columns.find(a => a.key === "MIET");
      let isImmoColVisible = immoCol ? this.showColumn(immoCol) : false;
      return this.showKompex && !this.isMietz && !this.showKompexOhneImmobilien  && !isImmoColVisible;
    }
  },
  watch: {
    activeStepNumber(newStep, oldStep) {
      if (newStep === 2) {
        if (oldStep === 1) {
          // check if selection on step 1 is valid
          this.isKompex = this.isKompex && this.gewerbeProductAvailable(this.personen, this.hasMvUnternehmen, ['SPEZ-PBV+MIET']);
          this.produkte = this.produkte.filter(p => this.gewerbeProductAvailable(this.personen, this.hasMvUnternehmen, p));

          this.hideNotKompex = this.isKompex;
          this.showKompex = this.isKompex || this.produkte.indexOf('FIRM') > -1;
        }
        this.setMatrixPraemien();
      }
    },
    isMietz(value) {
      if (value) this.showKompexOhneImmobilien = false;
    },
    immobilien: {
      deep: true,
      handler: function () {
        if (this.activeStepNumber === 2) this.setMatrixPraemien();
      }
    }
  },
  mounted() {
    if (this.$store.state.gewerbePraemien.praemien) this.setMatrixPraemien();
  },
  methods: {
    isSchublade() {
      if(this.excludeGF && this.showKompex) return true;
      if((this.anzahlMitarbeiter > 50) && this.showKompex) return true;
      return false;
    },
    setMatrixPraemien() {
      let praemien = {};
      const params = [this.mitarbeiter, this.fahrzeuge, this.immobilien, this.wohnungen, this.laufzeit, this.zahlweise];
      this.matrixDefinition.rows.forEach(sb => {
        praemien[`GW${sb.gewerbe}P${sb.privat}`] = {};
        this.matrixDefinition.columns.forEach(col => {
          let produkt = col.key;
          if (this.excludeGF) {
            if (col.kompex) produkt = [col.key].concat(['SPEZ-PRIVMINUSGF']);
            if (col.kompexOhneI) produkt = [col.key].concat(['SPEZ-PRIVMINUSGF']);
          }
          praemien[`GW${sb.gewerbe}P${sb.privat}`][col.key] = this.$store.getters.gewerbePrice(sb, produkt, ...params);
        });
      });
      this.matrixPraemien = praemien;
    },
    showColumn(col) {
      return (!col.kompex && !col.kompexOhneI && !this.hideNotKompex)
        || (this.showKompex && (col.kompex || col.kompexOhneI && this.showKompexOhneImmobilien));
    },
    showRow(row) {
      return this.showKompex || row.gewerbe !== '300' || row.privat !== '300';
    },
    isTileSelected(sb, produkt) {
      if (this.matrixSelection.sb.gewerbe === sb.gewerbe && this.matrixSelection.sb.privat === sb.privat) {
        if (!Array.isArray(produkt)) produkt = [produkt];
        for(let i=0; i < produkt.length; i++) {
          if(this.matrixSelection.produkte.indexOf(produkt[i]) < 0) return false;
        }
        return produkt.length === this.matrixSelection.produkte.length;
      }
      return false;
    },
    select(row, col) {
      this.$emit('gwproduct-selected');
      const sb = {
        gewerbe: row.gewerbe,
        privat: row.privat
      };
      const produkte = Array.isArray(col.key) ? col.key : [col.key];
      this.matrixSelection = {sb, produkte};
      this.isKompex = !!(col.kompex || col.kompexOhneI);
      this.isKompexOhneI = !!col.kompexOhneI;
      const allProdukte = produkte.concat(this.excludeGF && (col.kompex || col.kompexOhneI) ? ['SPEZ-PRIVMINUSGF'] : []);
      this.$store.dispatch('gewerbeUpdateMatrixDeckung', { sb, produkte: allProdukte });
    },
    excludeGFChanged() {
      this.setMatrixPraemien();
      const produkt = 'SPEZ-PRIVMINUSGF';
      if (this.excludeGF && this.matrixSelection.produkte.filter(p => /^SPEZ-PBV*/.test(p)).length > 0) {
        this.$store.dispatch('gewerbeAddZusatzDeckung', { person: 'vn1', sb: this.matrixSelection.sb, produkt });
      } else if (!this.excludeGF){
        this.$store.dispatch('gewerbeRemoveZusatzDeckung', { person: 'vn1', produkt });
      }
    },
    validateDialog () {
      this.$validator.validate('gewerbemitarbeiter.*').then((res) => {
        this.showMitarbeiterDialog = !res;
        if (res) {
          this.setMatrixPraemien();
          this.showKompex = true;
        }
      });
    }
  }
};
</script>
<style>
.gewerbepricematrix {
  min-width: 768px;
}

.gewerbepricematrix .bracket-text {
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.gewerbepricematrix .brackets {
  margin-bottom: -12px;
  z-index: 1;
  display: flex;
  flex-direction: row;
  color: rgba(0, 0, 0, 0.38);
  cursor: default;
}

.gewerbepricematrix .brackets .your-selection, .gewerbepricematrix .brackets .alternative {
  height: 8px;
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-bottom: none;
}

.gewerbepricematrix .brackets .alternative {
  border-color: #28a3b0;
}

.gewerbepricematrix .matrix-col {
  width: 110px;
  max-width: 110px;
  margin-left: 16px;
}

.gewerbepricematrix .matrix-col.small {
  width: 90px;
  max-width: 90px;
  margin-left: 8px;
}

.kompex-text {
  color: #077484;
}

.gewerbepricematrix .matrix-tile {
  width: 100%;
  height: 63px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  line-height: 1.3;
  border: 1px solid white;
  border-radius: 5px;
  cursor: default;
}

.gewerbepricematrix .matrix-tile.header-tile {
  position: relative;
  text-align: center;
}

.gewerbepricematrix .matrix-col.white.small + .matrix-col.white.small .header-tile::before {
  content: '+';
  position: absolute;
  left: -14px;
  color: rgba(0, 0, 0, 0.38);
}

.gewerbepricematrix .matrix-col.white.small + .matrix-col.beitrag .header-tile::before {
  content: '=';
  position: absolute;
  left: -14px;
  color: rgba(0, 0, 0, 0.38);
}

.gewerbepricematrix .beitrag .price-tile.selectable, .gewerbepricematrix .kompexohnei .price-tile.selectable,
.gewerbepricematrix .kompex .price-tile.selectable {
  cursor: pointer;
}

.gewerbepricematrix .white .price-tile {
  color: #0085CF;
  background: none;
  font-size: 16px;
  pointer-events: none;
}

.gewerbepricematrix .price-tile:not(.selectable) {
  pointer-events: none;
}

.gewerbepricematrix .beitrag .price-tile,
.gewerbepricematrix .kompex .price-tile,
.gewerbepricematrix .kompexohnei .price-tile {
  background-color: #f5f5f5;
  font-size: 20px;
}

.gewerbepricematrix .beitrag .price-tile {
  background-color: #ebebeb;
  color: #0085CF;
}

.gewerbepricematrix .beitrag .price-tile.selectable:hover {
  border-color: #0085CF;
}

.gewerbepricematrix .beitrag .price-tile.selected {
  color: white;
  background-color: #0085CF;
  border-color: #0085CF;
}

.gewerbepricematrix .kompex .header-tile,
.gewerbepricematrix .kompex .price-tile,
.gewerbepricematrix .kompexohnei .header-tile,
.gewerbepricematrix .kompexohnei .price-tile {
  color: #077484;
}


.gewerbepricematrix .kompex .schublade,
.gewerbepricematrix .kompexohnei .schublade {
  color: #f57f17 !important;
}

.gewerbepricematrix .kompex .price-tile.selectable:hover,
.gewerbepricematrix .kompexohnei .price-tile.selectable:hover{
  border-color: #077484;
}

.gewerbepricematrix .kompex .price-tile.selected,
.gewerbepricematrix .kompexohnei .price-tile.selected {
  color: white;
  background-color: #077484;
  border-color: #077484;
}

</style>
